// Upgrade browser carts from the former per-item request UI, like User App.
export const normalizeQrCartMemo = cart => {
    let memo = String(cart.b_memo || '');
    const entries = new Set();
    const item = (cart.item || []).map(source => {
        const {memo: legacyMemo, c_memo: legacyCartMemo, ...line} = source;
        const request = String(legacyCartMemo || legacyMemo || '').trim();
        if (request) entries.add(line.name ? `${line.name}: ${request}` : request);
        return line;
    });
    entries.forEach(entry => {
        if (!(`\n${memo}\n`).includes(`\n${entry}\n`)) {
            memo = Array.from(memo ? `${memo}\n${entry}` : entry).slice(0, 300).join('');
        }
    });
    return {...cart, item, b_memo: memo};
};
